var fieldBoxSlot = 'fx_2d2fb1e5_1vxzq8j0';

export { fieldBoxSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
